import { Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './services/services';
import { ErrorModalComponent } from './common/error-modal/error-modal.component';
import { Modal } from 'bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EncryptionService } from './services/encryption.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'axisnri-diy';
  appStarted: boolean = false;
  utmSource: string | null = "";
  utmMedium: string | null = "";
  utmCampaign: string | null = "";
  ref:string | null;
  pan: string | null;
  Pis: any;
  statusModal: any;
  pis:boolean = false;
  @ViewChild('errorComp') errorComp : ErrorModalComponent;
  public loader = inject(NgxUiLoaderService);
  public service = inject(AppService)
  public applicationNumber: string = "";
  encrypt = inject(EncryptionService);
  _http = inject(AppService);
  toastr = inject(ToastrService);
  search : {} = {};
   NRO: string = '';
  constructor(private router: Router){
    if(!this.appStarted){
      this.router.navigate(['/register'], { replaceUrl: true });
    }
  }

  ngOnInit(){
     
    let fullurl = window.location.href;
     if(window.top !== window.self && window.top?.location) {
        window.top.location.href = window.location.href;
      }
    this.utmSource = this.getParameterByName("utm_source",fullurl);
    this.utmMedium = this.getParameterByName("utm_medium",fullurl);
    this.utmCampaign = this.getParameterByName("utm_campaign",fullurl);
    this.ref = this.getParameterByName("ReferenceNumber",fullurl);
    this.pan = this.getParameterByName("PAN", fullurl);
    this.Pis = this.getParameterByName("Pis", fullurl);
    if(this.utmSource !== null){
      sessionStorage.setItem("utmSource",this.utmSource);
    }
    if(this.utmMedium !== null){
      sessionStorage.setItem("utmMedium",this.utmMedium);
    }
    if(this.utmCampaign !== null){
      sessionStorage.setItem("utmCampaign",this.utmCampaign);
    }
    if(this.Pis && (this.Pis === 'true' || this.Pis === true)){
      this.pis = true;
    }
    if(sessionStorage.getItem('NRO')) {
      this.NRO= sessionStorage.getItem('NRO') || '';
   }
    if(this.pan && this.ref){
      if(this.Pis){
        sessionStorage.setItem('pdfPis',this.Pis);
      }
      sessionStorage.setItem("pdfPan", this.pan);
      sessionStorage.setItem("pdfRef", this.ref);
      setTimeout(() => {
        const element = document.getElementById('appstatus') as HTMLElement;
        this.statusModal = new Modal(element, {backdrop: 'static', keyboard: false});
        this.statusModal.show();
      }, 0);
      
    }
    if (location.search) {
      this.search = this.getParams(location.search);
    } else if (sessionStorage.getItem('searchParams')) {
      this.search = JSON.parse(sessionStorage.getItem('searchParams') || '{}');
    }
  }


  getParameterByName(name:string, url:string) {
    //if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&|]" + name + "(=([^&#|]*)|&|#|$)", 'i'),
    results = regex.exec(url);
    if (!results)
      return null;
    if (!results[2])
      return '';
    return results[2].replace(/\+/g, " ");
  }

  appStatus(event: boolean){
    this.appStarted = event;
    this.service.setStatusLoad(event);
    if(this.appStarted){
      this.NRO = sessionStorage.getItem('NRO') || '';
    }
  }

  getParams(event : string) : object {
    const searchParams = new URLSearchParams(event);
    let obj : any = {};
    for (const [key, value] of searchParams.entries()) {
      obj[key.toLowerCase()] = value.toLowerCase();
    }
    if (Object.keys(obj).length > 0) {
      sessionStorage.setItem('searchParams', JSON.stringify(obj));
    }
    return obj;
  }

  downloadAOF(action:boolean,ref:string | null, pan:string | null){
    this.loader.start();
    const path = "DIY/DiyAofDownload";
    const params = {
        "ReferenceNumber": ref,
        "Guid" : 0,
        "pannumber": pan,
        "pdf": action ? "AOF" : 'PIS'
    }
    const checkSum = ref;
    this._http.httpPost(path, params, checkSum).subscribe({
        next:(data:any)=>{
          this.loader.stop();
          let val = this.encrypt.decryptUsingAES256(data.OutPut)
            if(val.IsSuccess){
              this.applicationNumber = val.ReferenceNumber;
              if (val.Pdf && action) {
                const byteArray = new Uint8Array(atob(val.Pdf).split("").map(char => char.charCodeAt(0)));
                // const pdfContent = atob(data.Pdf);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const filename = this.applicationNumber ? `${this.applicationNumber}.pdf` : `Aof.pdf`;
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                setTimeout(() => {
                    a.click();
                    URL.revokeObjectURL(url);
                }, 0);
                // this.toastr.success("PDF Downloaded Successfully");
                // this.statusModal.hide();
              }
              else if (val.PISPdf && !action) {
                const byteArray = new Uint8Array(atob(val.PISPdf).split("").map(char => char.charCodeAt(0)));
                // const pdfContent = atob(data.Pdf);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const filename = this.applicationNumber ? `${this.applicationNumber}_NREPIS.pdf` : `NREPIS.pdf`;
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                setTimeout(() => {
                    a.click();
                    URL.revokeObjectURL(url);
                }, 0);
                // this.toastr.success("PDF Downloaded Successfully");
                // this.statusModal.hide();
              } 
              else {
                this.errorComp.ModalShow("PDF content not found in the response.");
                // this.toastr.error("PDF content not found in the response.");
              }
            }else{
              this.statusModal.hide();
              this.errorComp.ModalShow(val.Error || "PDF content not found");
              // this.toastr.error(val.Error);
            }
        },error: e => {
            this.loader.stop();
            this.statusModal.hide();
            this.errorComp.ModalShow(e.error.Message);
            // this.toastr.error(e.error.Message);

        }
    });
  }
}
